/**
 * Mapping of countries to their respective currency codes
 */
export const COUNTRY_TO_CURRENCY_MAP: Record<string, string> = {
  'Canada': 'CAD',
  'USA': 'USD',
  'India': 'INR',
  'Europe': 'EUR',
  'UK': 'GBP'
};
